module.exports = __webpack_public_path__ + "static/media/popout.f75bc456.svg";